import designTokensDark from './designTokensDark';

// 主题唯一标识
designTokensDark['T_THEME'] = 'dark';

export default {
    designTokens: designTokensDark
};
